import translationEN from "./en/translation.json";
import translationFR from "./fr/translation.json";

const lang = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

export default lang;
